import React, { useEffect } from 'react';

const AchievementPopup = ({ title, description, emoji, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="fixed top-4 right-4 z-50 max-w-sm">
      <div className="bg-gradient-to-r from-purple-500 to-pink-500 text-white p-4 rounded-2xl shadow-xl animate-slideInUp">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center text-2xl flex-shrink-0">
            {emoji}
          </div>
          <div className="flex-1">
            <h4 className="font-bold text-base mb-1">{title}</h4>
            <p className="text-sm opacity-90">{description}</p>
          </div>
          <button
            onClick={onClose}
            className="w-6 h-6 rounded-full bg-white bg-opacity-20 flex items-center justify-center text-sm hover:bg-opacity-30 transition-all"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

export default AchievementPopup;